import React from "react";
import { withRouter } from "react-router-dom";
import { Typography, LinkText } from "../../ecosystem/";
import { DashboardTile } from "../DashboardTile";
import { getFirstName } from "../../../helpers/formatting";
import { logUI } from "../../../api/andyliticsApi";
import * as Tools from "../../../helpers/Tools";

export function AfterVisitSummaryTile({
    avs,
    isMobile = false
}) {

    const encryptedCSN = avs && avs.encryptedCSN ? avs.encryptedCSN : '';
    const avsDate = avs && avs.date ? Tools.getDateStrByFormat(avs.date, 'MM/DD/YYYY') : '';
    const patientName = avs && avs.patientName ? getFirstName(avs.patientName) : '';
    const patientExternalId = avs && avs.patientExternalId ? avs.patientExternalId : '';

    return (
        <DashboardTile
            className="appt-refresh-avs-tile"
        >
            <div className="col-12 avs-tile-body">
                <div>
                    <LinkText
                        to={{ pathname: "/visitsummary", state: { csnId: encryptedCSN, Id: patientExternalId } }}
                        onClick={() => logUI("MBHWeb.Dashboard.AVS.Tile.Click", new Date(), Tools.getURLPath(), { Id: patientExternalId })}
                        typographyType="heading-01"
                    >
                        After Visit Summary
                    </LinkText>
                    <Typography type="body-02" tag={isMobile ? "div" : "span"}> for {patientName}</Typography>
                </div>
                <Typography type={isMobile ? "body-01" : "body-02"} tag="div" textAlign="right">{avsDate}</Typography>
            </div>
        </DashboardTile>
    );
}

export default withRouter(AfterVisitSummaryTile);


